var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-map h-100"},[_c('div',{ref:"mapDom",staticClass:"h-100"})])}
var staticRenderFns = []

export { render, staticRenderFns }